import { useNavigate } from 'react-router';
import { Icon, IconRail, Tooltip, icons } from '@agentisai/design-system';

/**
 * The rail entry to Agent Monitor (D15-06). A navigation, not a panel
 * disclosure — so `aria-expanded` (which `IconRail.Button` sets for its
 * disclosures) is cleared. Every tenant member sees it: Overview is for all
 * three tiers; the pages beyond it are role-gated inside the monitor.
 */
export function AgentMonitorRailLink({ active = false }: { readonly active?: boolean }) {
  const navigate = useNavigate();
  return (
    <Tooltip content="Agent Monitor">
      <IconRail.Button
        aria-label="Agent Monitor"
        aria-expanded={undefined}
        aria-current={active ? 'page' : undefined}
        active={active}
        icon={<Icon as={icons.Activity} size={20} />}
        onClick={() => void navigate('/monitor')}
      />
    </Tooltip>
  );
}
AgentMonitorRailLink.displayName = 'AgentMonitorRailLink';
